


export class GLOBALS {

    public static RENDER_REPORTE_PRODUCCION: number = 250;
    public static RENDER_REPORTE_DATOS_FINANCIEROS: number = 300;
    public static NO_SELECTED_OPTION: number = -1;

    public static FORMAT_HEADER: string = "Header";
    public static FORMAT_SUB_HEADER: string = "Subheader";

}